import {InfoBlock} from './InfoBlock';
import {collision} from './collision';

export class Coin {
	constructor(game) {
		this.game = game;
		this.image = document.getElementById('coin');
		this.frameX = 0;
		this.maxFrame = 7;
		this.frameY = 0;
		this.fps = 16;
		this.frameTimer = 0;
		this.framInterval = 1000 / this.fps;
		this.imageScale = 0.4;
		this.x = this.setStartX();
		this.y = this.game.height - 450;
		this.spriteWidth = 192;
		this.spriteHeight = 192;
		this.width = this.spriteWidth * this.imageScale;
		this.height = this.spriteHeight * this.imageScale;
		this.collisiion = false;
		this.show = false;
		this.infoBlock = new InfoBlock(game);
		// this.multiplicity = Math.round((this.game.maxBlocks - 3) / this.infoBlock.content.length);
		this.multiplicity = 1;
		this.cost = 5;
		this.stopShow = false;
		this.speed = this.game.speed * 1.1;
		this.count = 0;
	}

	spriteUpdate(deltaTime) {
		// sprite animation
		if (this.frameTimer > this.framInterval) {
			if (this.frameX >= this.maxFrame) {
				this.frameX = 0;
			} else {
				this.frameX++;
			}

			this.frameTimer = 0;
		} else {
			this.frameTimer += deltaTime;
		}
	}

	setStartX() {
		return this.game.width + this.game.width / 4;
	}

	update(deltaTime) {
		if (this.game.currentBlocks
			&& this.game.currentBlocks % this.multiplicity === 0
			&& !this.show
			&& !this.stopShow
		) {
			this.show = true;
			this.count++;

			if (this.count > this.infoBlock.content.length) {
				this.stopShow = true;
			}
		}

		if (collision(this.game.player, this) && !this.collisiion) {
			this.game.sound.playCoin();

			this.collisiion = true;
			this.game.updateScore(this.cost);

			this.infoBlock.open();
			this.game.pause();
		}

		if (this.show && this.x + this.width >= 0 && !this.stopShow) {
			this.x -= this.speed;
		} else if (this.game.showNewBlocks) {
			this.show = false;
			this.x = this.setStartX();
			this.collisiion = false;
		}

		this.spriteUpdate(deltaTime);
	}

	draw() {
		if (!this.collisiion) {
			this.game.ctx.drawImage(
				this.image,
				this.frameX * this.spriteWidth,
				this.frameY * this.spriteHeight,
				this.spriteWidth,
				this.spriteHeight,
				this.x,
				this.y,
				this.width,
				this.height,
			);
			// this.game.ctx.drawImage(this.image, this.x, this.y, this.width, this.height);
		}
	}

	resize() {
		this.x = this.game.width;
		this.y = this.game.height - 500;
	}

	reset() {
		this.x = this.width;
		this.show = false;
		this.stopShow = false;
		this.count = 0;
		this.infoBlock.reset();
	}
}
